import React from 'react';
import Icon from '../../../components/AppIcon';

const GoalTracker = ({ goals }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'achieved':
        return 'text-green-600 bg-green-50 border-green-200';
      case 'on-track':
        return 'text-blue-600 bg-blue-50 border-blue-200';
      case 'at-risk':
        return 'text-yellow-600 bg-yellow-50 border-yellow-200';
      case 'behind':
        return 'text-red-600 bg-red-50 border-red-200';
      default:
        return 'text-gray-600 bg-gray-50 border-gray-200';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'achieved':
        return 'CheckCircle';
      case 'on-track':
        return 'TrendingUp';
      case 'at-risk':
        return 'AlertCircle';
      case 'behind':
        return 'AlertTriangle';
      default:
        return 'Target';
    }
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <div className="mb-6">
        <h2 className="text-lg font-semibold text-gray-900 mb-1">Goal Tracker</h2>
        <p className="text-sm text-gray-600">Business objectives and progress monitoring</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {goals?.map((goal, index) => (
          <div key={index} className="border border-gray-200 rounded-lg p-5">
            <div className="flex items-start justify-between mb-4">
              <div>
                <h3 className="text-sm font-semibold text-gray-900 mb-1">{goal?.title}</h3>
                <p className="text-xs text-gray-500">
                  {typeof goal?.current === 'number' && goal?.current > 1000 
                    ? `$${goal?.current?.toLocaleString()}` 
                    : goal?.current} / {typeof goal?.target === 'number' && goal?.target > 1000 
                    ? `$${goal?.target?.toLocaleString()}` 
                    : goal?.target}
                </p>
              </div>
              <span className={`px-3 py-1 rounded-full text-xs font-medium border flex items-center gap-1 ${getStatusColor(goal?.status)}`}>
                <Icon name={getStatusIcon(goal?.status)} className="w-3 h-3" />
                {goal?.status?.replace('-', ' ')?.toUpperCase()}
              </span>
            </div>

            {/* Progress Bar */}
            <div className="mb-3">
              <div className="w-full bg-gray-200 rounded-full h-3">
                <div 
                  className={`h-3 rounded-full transition-all ${
                    goal?.status === 'achieved' ? 'bg-green-600' :
                    goal?.status === 'on-track' ? 'bg-blue-600' :
                    goal?.status === 'at-risk'? 'bg-yellow-600' : 'bg-red-600'
                  }`}
                  style={{ width: `${Math.min(goal?.progress, 100)}%` }}
                />
              </div>
            </div>

            {/* Progress Percentage */}
            <div className="flex items-center justify-between">
              <span className="text-sm text-gray-600">Progress</span>
              <span className="text-sm font-semibold text-gray-900">{goal?.progress}%</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GoalTracker;